export default __webpack_public_path__ + "static/media/valves-for-home-page.4e4603f3.png";